import React, { useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getExperience, resetExperience } from '../../../store/actions/experience';
import { RootState } from '../../../types/data';
import { MathUtils } from 'three';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import Player from '../../../components/xr/player';
import BookingWindow from '../booking';
import { VideoSpaceResourceId } from '../../../common/constants/xr';
import { MediaType, MediaEvents } from '../../../common/media';
import { useMedia } from '../../../hooks';
import GatewayService from '../../../services/gateway-service';
import { EXPERIENCE_ENDED } from '../../../common/constants/gateway-events';

const { degToRad } = MathUtils;

type ExperienceVideoSpaceProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<{ experienceId?: string }>;

const ExperienceVideoSpace = ({ experience }: ExperienceVideoSpaceProps) => {
  const media = useMedia(VideoSpaceResourceId, MediaType.Video);
  const location = useLocation();
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const showPlayer = Number(params.playerMode) !== 2;
  const showBookingWindow = showPlayer && Number(params.playerMode) !== 1;

  useEffect(() => {
    media.on(MediaEvents.Ended, () =>
      GatewayService.emit(EXPERIENCE_ENDED, {
        type: 'experience_video',
      })
    );
  }, [media]);

  return (
    <group>
      <group position={[0, 0, 0]}>
        <group position={[0, -0.5, -1]} scale={[1.5, 1.5, 1.5]} rotation={[degToRad(-15), 0, 0]}>
          {showBookingWindow ? <BookingWindow data={experience.data} position={[0, 0.1, 0]} /> : null}
          {showPlayer ? <Player position={[0, 0, 0]} target={VideoSpaceResourceId} mode="video" /> : null}
        </group>
      </group>
    </group>
  );
};

const mapStateToProps = (state: RootState) => ({
  experience: state.experience?.current,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getExperience,
      resetExperience,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExperienceVideoSpace));
